import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-to-cart-counter" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuantityCounterTwo',
  props: {
    btnColor: {},
    bgClass: {}
  },
  setup(__props: any) {

const props = __props;

const internalValue = ref<number>(1);

const increment = () => {
  internalValue.value++;
};

const decrement = () => {
  if (internalValue.value > 0) {
    internalValue.value--;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "submit",
      class: _normalizeClass(['minusBtn', __props.btnColor]),
      onClick: decrement
    }, null, 2),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      size: "25",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
      class: _normalizeClass(['count', __props.bgClass])
    }, null, 2), [
      [_vModelText, internalValue.value]
    ]),
    _createElementVNode("button", {
      type: "submit",
      class: _normalizeClass(['plusBtn', __props.btnColor]),
      onClick: increment
    }, null, 2)
  ]))
}
}

})